import { LogoFragment } from "src/__generated__/cms-schema.codegen";
import {
	StructuredText,
	StructuredTextData,
} from "src/components/StructuredText/StructuredText";
import { DatoAsset } from "../../components/Dato/DatoAsset";
import { Hx } from "../../components/Heading/Heading";

export type LogoWallSectionProps = {
	title: string;
	subtitle?: StructuredTextData;
	logos: Array<LogoFragment>;
	backgroundColor: string;
	color: string;
};

export const LogoWallSection: React.FC<LogoWallSectionProps> = ({
	title,
	subtitle,
	logos,
	backgroundColor,
	color,
}) => {
	return (
		<div
			style={{
				backgroundColor,
				color,
			}}
		>
			<div className="max-w-(--breakpoint-xl) mx-auto py-8 flex flex-col gap-7">
				<div className="flex flex-col gap-1 items-center text-center px-4">
					<Hx
						size="h6"
						style={{
							color,
						}}
					>
						{title}
					</Hx>
					{subtitle && (
						<div className="[&>p]:text-sm">
							<StructuredText data={subtitle} />
						</div>
					)}
				</div>
				<div className="flex flex-wrap justify-center items-start gap-x-32 gap-y-12 mx-auto py-4 px-16 lg:px-64">
					{logos.map(({ id, title, logo }) => {
						return (
							<div
								key={id}
								className="flex flex-col items-center gap-2"
							>
								<div className="overflow-hidden flex justify-center h-10 w-24">
									<DatoAsset
										className="w-full block object-cover fill-white"
										data={logo}
									/>
								</div>
								<span className="text-xs text-center">
									{title}
								</span>
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
};

// 🔬 e2e: story
